import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const KYCApprovedSection = () => {
  const navigate = useNavigate();

  return (
    <div className="kyc-approved-card">
      <div className="kyc-approved-card__icon">
        <ShieldCheck size={36}/>
      </div>
      <h4>Account Verified!</h4>
      <p>Congratulations! Your account is fully verified. You can now bid on jobs and start earning.</p>
      <button className="kyc-cta-btn" onClick={() => navigate('/worker-dashboard')}>
        Go to Dashboard
      </button>
    </div>
  );
};

export default KYCApprovedSection;